module.exports = __webpack_public_path__ + "img/28.58f15e10.png";